import { asap, safeCallback } from "../helpers/fn.js";
import { isFunction } from "../helpers/is-type.js";
import { createSubject } from "../helpers/subject.js";
import { observable } from "../observable/index.js";
//#region ../r-html/dist/store/index.js
function createAction(type) {
	function actionCreator(payload) {
		return {
			type,
			payload
		};
	}
	actionCreator.toString = () => `${type}`;
	actionCreator.type = type;
	return actionCreator;
}
function* compositionActionsFlat$(state, ctx, iterator) {
	for (const value of iterator) if (value?.[Symbol.iterator]) yield* compositionActionsFlat$(state, ctx, value);
	else if (isFunction(value)) yield* compositionActionsFlat$(state, ctx, value(state, ctx));
	else yield value;
}
var compositionActionsFlat = (state, ctx, compositionActions) => [...compositionActionsFlat$(state, ctx, compositionActions)];
var pipe = (...operators) => (initSource) => operators.reduce((source, operator) => operator(source), initSource);
function* createSource(actions) {
	yield actions;
}
var notEmptyActions = function* (source) {
	for (const actions of source) if (actions.length) yield actions;
};
function createStore({ context, state: initialState, reducers, enableObservable = true }) {
	const state = enableObservable ? observable(initialState) : initialState;
	const beforeSubject = createSubject();
	const subject = createSubject();
	let operator = pipe(notEmptyActions);
	const runReducer = (action) => {
		const reducer = Reflect.get(reducers, action.type, reducers);
		safeCallback(reducer, state, action, context);
	};
	const dispatchSync = (...compositionActions) => {
		const actions = compositionActionsFlat(state, context, compositionActions);
		beforeSubject.next(actions);
	};
	const dispatch = (...compositionActions) => {
		asap(() => dispatchSync(...compositionActions));
	};
	const connectUnsubscribe = beforeSubject.subscribe((actions) => {
		const iter = operator(createSource(actions));
		for (const value of iter) subject.next(value);
	});
	const unsubscribe = subject.subscribe((actions) => actions.forEach(runReducer));
	const _pipe = (...operators) => {
		operator = pipe(...operators, notEmptyActions);
		return () => {
			operator = pipe(notEmptyActions);
		};
	};
	const destroy = () => {
		connectUnsubscribe();
		unsubscribe();
	};
	return {
		context,
		state,
		dispatch,
		dispatchSync,
		subscribe: subject.subscribe,
		pipe: _pipe,
		destroy
	};
}
//#endregion
export { compositionActionsFlat, createAction, createStore };
